import React, { ReactNode } from 'react';
import { IWprControlProps } from '../props/IWprControlProps';
import { WprBaseControlComponent } from './WprBaseControlComponent';
import { WprControlVisibility } from '../props/IWprControlState';

/**
 * Text要素コントロールプロパティ情報
 */
interface IWprTextProps extends IWprControlProps {
	converter?: string;			// コンバータ
}

/**
 * Text要素コントロール
 */
export class WprText extends WprBaseControlComponent<IWprTextProps, HTMLElement> {
	// プロパティ  ---------------------------------------------------------------
	/** 編集フラグ */
	public get isEdit(): boolean	{ return false; 	}
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	constructor(props: IWprTextProps){
		super(props);
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * 値取得
	 * @returns 値
	 */
	protected getValue(): any {
		return undefined;
	}

	/**
	 * 描画
	 */
	public onRender(): ReactNode {
		if (this.state.visibility === WprControlVisibility.COLLAPSED)
			return <></>;
		let text = '';
		if (this.state.visibility === WprControlVisibility.VISIBLE)
			text = this.getStateValue();
		text = text.replace(/</g, '').replace(/>/g, '');
		return (
			<>
				{text}
			</>
		);
	}
	// --------------------------------------------------------------------------

	// private メソッド  --------------------------------------------------------
	/**
	 * ステータスの値を取得する
	 * @returns ステータスの値
	 */
	private getStateValue(): string {
		if (this.props.converter)
			return this.convertValue(this.props.converter, this.state.value);
		return this.state.value;
	}
	// --------------------------------------------------------------------------
}